import { useVariant } from '@calendly/feature-check-react'

import { hasOnboardingPaymentsFlag } from '../../../hooks/growth_experiments/use-onboarding-payments-experiment'

const SURFACE_ET_PAYMENTS_UPFRONT_EXPERIMENT_KEY = 'growth_surface_et_payments_upfront'

const SURFACE_ET_PAYMENTS_UPFRONT_VARIANTS = {
  CONTROL: 'control',
  VARIANT_1: 'variant_1',
  VARIANT_2: 'variant_2',
}

export const isSurfaceEtPaymentsUpfrontEligible = () => hasOnboardingPaymentsFlag()

const getSurfaceEtPaymentsUpfrontVariant = (variant) => (
  [
    SURFACE_ET_PAYMENTS_UPFRONT_VARIANTS.VARIANT_1,
    SURFACE_ET_PAYMENTS_UPFRONT_VARIANTS.VARIANT_2
  ].includes(variant) ? variant : null
)

export const SurfaceEtPaymentsUpfrontExperiment = ({ children }) => {
  const variant = useVariant(SURFACE_ET_PAYMENTS_UPFRONT_EXPERIMENT_KEY)

  return children(getSurfaceEtPaymentsUpfrontVariant(variant))
}
